<template>
  <VLayout>
    <VFlex
      xs4
      sm2
    >
      <VMenu
        ref="menu_from"
        v-model="menu.from"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        full-width
        lazy
        max-width="290px"
        min-width="290px"
      >
        <VTextField
          slot="activator"
          v-model="from"
          :label="$t('form.date_from')"
          prepend-icon="event"
          readonly
        />
        <VDatePicker
          v-model="from"
          :avtosave="true"
          no-title
          scrollable
          actions
        />
      </VMenu>
    </VFlex>
    <VFlex
      xs4
      sm2
    >
      <VMenu
        ref="menu_to"
        v-model="menu.to"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <VTextField
          slot="activator"
          v-model="to"
          :label="$t('form.date_to')"
          prepend-icon="event"
          readonly
        />
        <VDatePicker
          v-model="to"
          :avtosave="true"
          :min="from"
          no-title
          scrollable
          actions
        />
      </VMenu>
    </VFlex>
    <VSpacer />
    <slot name="tools" />
  </VLayout>
</template>

<script>

export default {
  name: 'DateControlPanel',
  data() {
    return {
      menu: {
        to: false,
        from: false,
      },
      from: null,
      to: null,
    };
  },

  watch: {
    from() {
      this.update();
    },
    to() {
      this.update();
    },
  },

  async created() {
    const date = await this.$store.dispatch('shared/getDate');
    this.from = date.from;
    this.to = date.to;
    this.$emit('created', true);
  },

  methods: {
    update() {
      this.$store.dispatch('shared/setDate', {
        from: this.from,
        to: this.to,
      });
    },
  },
};
</script>
